import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchPitchYourStoryPageData } from "content-ui/utilityPages/pitch-your-story/fetcher";

import PitchYourStoryView from "content-ui/utilityPages/pitch-your-story";
import { SEO_SIFTED_ON_PINK_IMAGE } from "lib/constants/shared";
import ErrorBoundary from "components/errorBoundary/errorBoundary";

import type { PitchYourStoryPageData } from "content-ui/utilityPages/pitch-your-story/types";

export async function getStaticProps({ preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchPitchYourStoryPageData({ preview }),
  ]);

  return {
    props: {
      __initialState: {
        sitewideOption: { ...menuItems },
      },
      dato,
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  dato: PitchYourStoryPageData;
};

const PitchYourStoryPage = (props: PageProps) => {
  const { seo } = props.dato.pitchYourStoryPage;

  const title = seo?.title || "Pitch Your Story | Sifted";
  const description = seo?.description || "Sifted | Pitch Your Story";
  const seoImage = seo?.image?.url || SEO_SIFTED_ON_PINK_IMAGE;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/pitch-your-story"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: seoImage }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <PitchYourStoryView data={props.dato?.pitchYourStoryPage} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default PitchYourStoryPage;
